window.addEventListener('DOMContentLoaded', () => {
    let result = document.querySelectorAll(".blogcontent iframe[src*='youtube']");
    let targets = [].slice.call(result);

    result = document.querySelectorAll(".blogcontent iframe[src*='vimeo']");
    targets = targets.concat([].slice.call(result));

    targets.forEach((target) => {
        const parent = document.createElement('div');
        parent.className = 'embed';
        target.parentNode.appendChild(parent);
        return parent.appendChild(target);        
    });
});
